import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.css']
})
export class AddComponent implements OnInit {
  title = 'Øv dig i at lægge tal sammen';
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/add/add.component.ts